import React from 'react'
import { Box, Typography } from '@mui/material'

function LogInHeader() {
  return (
    <>
      <Box>
        <img
          src='https://sg1-sharedresources-dashboardbeepluginuploads3buc-1qsv7f850xocz.s3.amazonaws.com/images/RZK-774-875Z/editor_images/header%20logo.png'
          alt='Circles Logo'
          style={{
            height: '50px',
            marginLeft: -30
          }}
        />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '2em', fontWeight: '900' }}>
          Welcome to Orbit
        </Typography>
      </Box>
    </>
  )
}

LogInHeader.propTypes = {}

export default LogInHeader
